module.exports = __webpack_public_path__ + "img/010098.383f11b8.png";